import { Action } from "@ngrx/store"
import {
    ContactInfo, DnvLatLng, ErrorExport, ImageFile, ImageFilePayload,
    ImageFileStatusUpdate, ProblemMenuInputSuggestion, ProblemMenuItem,
    ProblemMenuSelection, QuestionAnswer, QuestionsPayload
} from ".";

export const ApplicationActionType = {
    GetProblemMenuConfig: '[application] GetProblemMenuConfig',
    SetProblemMenuConfigItems: '[application] SetProblemMenuConfigItems',
    GetProblemMenuConfigError: '[application] GetProblemMenuConfigError',
    SetUnmodifiableMenuConfig: '[application] SetUnmodifiableMenuConfig',
    ResetProblemMenuItems: '[application] ResetProblemMenuItems',
    FilterProblemMenuItems: '[application] FilterProblemMenuItems',
    SetFilterProblemMenuItemCount: '[application] SetFilterProblemMenuItemCount',
    UpdateProblemMenuDropdownState: '[application] UpdateProblemMenuDropdownState',
    SetCurrentStep: '[application] SetCurrentStep',
    SetSelectedProblemMenuItemConfig: '[application] SetSelectedProblemMenuItemConfig',
    SetSelectedProblemMenuItemSuccess: '[application] SetSelectedProblemMenuItemSuccess',
    SetSelectedCoordinates: '[application] SetSelectedCoordinates',
    SetSelectedLocationNameOrigin: '[application] SetSelectedLocationNameOrigin',
    SetSelectedLocationName: '[application] SetSelectedLocationName',
    SetProblemDetails: '[application] SetProblemDetails',
    SubmitPhoto: '[application] SubmitPhoto',
    SavePhoto: '[application] SavePhoto',
    ValidatePhotoUpload: '[application] ValidatePhotoUpload',
    UpdatePhotoUploadStatus: '[application] UpdatePhotoUploadStatus',
    RemovePhoto: '[application] RemovePhoto',
    RemoveErrorPhotos: '[application] RemoveErrorPhotos',
    SetContactInfo: '[application] SetContactInfo',
    ClearSelectedProblemMenuItem: '[application] ClearSelectedProblemMenuItem',
    ClearSelectedProblemMenuItemSuccess: '[application] ClearSelectedProblemMenuItemSuccess',
    ClearSelectedLatLngCoordinates: '[application] ClearSelectedLatLngCoordinates',
    ClearProblemDetails: '[application] ClearProblemDetails',
    ClearProblemPhotos: '[application] ClearProblemPhotos',
    ClearContactInfo: '[application] ClearContactInfo',
    CreateProblemStub: '[application] CreateProblemStub',
    CreateProblemStubSuccess: '[application] CreateProblemStubSuccess',
    CreateProblemStubError: '[application] CreateProblemStubError',
    SubmitProblem: '[application] SubmitProblem',
    SubmitProblemSuccess: '[application] SubmitProblemSuccess',
    SubmitProblemError: '[application] SubmitProblemError',
    GetProblemQuestions: '[application] GetProblemQuestions',
    GetProblemQuestionsSuccess: '[application] GetProblemQuestionsSuccess',
    GetProblemQuestionsError: '[application] GetProblemQuestionsError',
    ConvertProblemQuestions: '[application] ConvertProblemQuestions',
    ConvertProblemQuestionsSuccess: '[application] ConvertProblemQuestionsSuccess',
    SetAnsweredProblemQuestions: '[application] SetAnsweredProblemQuestions',
    ResetAnsweredProblemQuestions: '[application] ResetAnsweredProblemQuestions',
    SaveProblemTypeSearchLog: '[application] SaveProblemTypeSearchLog',
    CreateSaveSearchStubError: '[application] CreateSaveSearchStubError',
    JumpToSystemError: '[application] JumpToSystemError',
    ResetState: '[application] ResetState',
    NoAction: '[application] NoAction',
    DelayedActionBy1s: '[application] DelayedActionBy1s',
};

export class GetProblemMenuConfig implements Action {
    public type: string = ApplicationActionType.GetProblemMenuConfig;
    constructor() { };
};

export class SetProblemMenuConfigItems implements Action {
    public type: string = ApplicationActionType.SetProblemMenuConfigItems;
    constructor(public payload?: ProblemMenuItem[]) { }
};

export class GetProblemMenuConfigError implements Action {
    public type: string = ApplicationActionType.GetProblemMenuConfigError;
    constructor(public payload: any) { }
};

export class ResetProblemMenuItems implements Action {
    public type: string = ApplicationActionType.ResetProblemMenuItems;
    constructor() { }
}

export class SetUnmodifiableMenuConfig implements Action {
    public type: string = ApplicationActionType.SetUnmodifiableMenuConfig;
    constructor(public payload?: ProblemMenuItem[]) { }
};

export class FilterProblemMenuItems implements Action {
    public type: string = ApplicationActionType.FilterProblemMenuItems;
    constructor(public payload?: string) { }
};

export class SetFilterProblemMenuItemCount implements Action {
    public type: string = ApplicationActionType.SetFilterProblemMenuItemCount;
    constructor(public payload?: number) { }
};

export class UpdateProblemMenuDropdownState implements Action {
    public type: string = ApplicationActionType.UpdateProblemMenuDropdownState;
    constructor(public payload?: ProblemMenuItem[]) { }
};

export class SetCurrentStep implements Action {
    public type: string = ApplicationActionType.SetCurrentStep;
    constructor(public payload?: number) { }
};

export class SetSelectedProblemMenuItemConfig implements Action {
    public type: string = ApplicationActionType.SetSelectedProblemMenuItemConfig;
    constructor(public payload?: ProblemMenuSelection) { }
};

export class SetSelectedProblemMenuItemSuccess implements Action {
    public type: string = ApplicationActionType.SetSelectedProblemMenuItemSuccess;
    constructor(public payload?: ProblemMenuItem[]) { }
};

export class SetSelectedCoordinates implements Action {
    public type: string = ApplicationActionType.SetSelectedCoordinates;
    constructor(public payload?: DnvLatLng) { }
};

export class SetSelectedLocationNameOrigin implements Action {
    public type: string = ApplicationActionType.SetSelectedLocationNameOrigin;
    constructor(public payload?: string) { }
};

export class SetSelectedLocationName implements Action {
    public type: string = ApplicationActionType.SetSelectedLocationName;
    constructor(public payload?: string) { }
}

export class SetProblemDetails implements Action {
    public type: string = ApplicationActionType.SetProblemDetails;
    constructor(public payload?: string) { }
};

export class SubmitPhoto implements Action {
    public type: string = ApplicationActionType.SubmitPhoto;
    constructor(public payload: ImageFilePayload) { }
};

export class SavePhoto implements Action {
    public type: string = ApplicationActionType.SavePhoto;
    constructor(public payload?: ImageFile) { }
};

export class ValidatePhotoUpload implements Action {
    public type: string = ApplicationActionType.ValidatePhotoUpload;
    constructor(public payload?: ImageFile) { }
};

export class UpdatePhotoUploadStatus implements Action {
    public type: string = ApplicationActionType.UpdatePhotoUploadStatus;
    constructor(public payload: ImageFile) { }
};

export class RemovePhoto implements Action {
    public type: string = ApplicationActionType.RemovePhoto;
    constructor(public payload: string) { }
};

export class RemoveErrorPhotos implements Action {
    public type: string = ApplicationActionType.RemoveErrorPhotos;
    constructor() { }
};

export class SetContactInfo implements Action {
    public type: string = ApplicationActionType.SetContactInfo;
    constructor(public payload?: ContactInfo) { }
};

export class ClearSelectedProblemMenuItem implements Action {
    public type: string = ApplicationActionType.ClearSelectedProblemMenuItem;
    constructor() { }
};

export class ClearSelectedProblemMenuItemSuccess implements Action {
    public type: string = ApplicationActionType.ClearSelectedProblemMenuItemSuccess;
    constructor(public payload?: ProblemMenuItem[]) {}
};

export class ClearSelectedLatLngCoordinates implements Action {
    public type: string = ApplicationActionType.ClearSelectedLatLngCoordinates;
    constructor() { }
};

export class ClearProblemDetails implements Action {
    public type: string = ApplicationActionType.ClearProblemDetails;
    constructor() { }
};

export class ClearProblemPhotos implements Action {
    public type: string = ApplicationActionType.ClearProblemPhotos;
    constructor() { }
};

export class ClearContactInfo implements Action {
    public type: string = ApplicationActionType.ClearContactInfo;
    constructor() { }
};

export class CreateProblemStub implements Action {
    public type: string = ApplicationActionType.CreateProblemStub;
    constructor() { }
};

export class CreateProblemStubSuccess implements Action {
    public type: string = ApplicationActionType.CreateProblemStubSuccess;
    constructor(public payload: string) { }
};

export class CreateProblemStubError implements Action {
    public type: string = ApplicationActionType.CreateProblemStubError;
    constructor() { }
};

export class SubmitProblem implements Action {
    public type: string = ApplicationActionType.SubmitProblem;
    constructor() { }
};

export class SubmitProblemSuccess implements Action {
    public type: string = ApplicationActionType.SubmitProblemSuccess;
    constructor(public payload?: string) { }
};

export class SubmitProblemError implements Action {
    public type: string = ApplicationActionType.SubmitProblemError;
    constructor() { }
};

export class GetProblemQuestions implements Action {
    public type: string = ApplicationActionType.GetProblemQuestions;
    constructor(public payload?: number) { }
};

export class GetProblemQuestionsSuccess implements Action {
    public type: string = ApplicationActionType.GetProblemQuestionsSuccess;
    constructor(public payload?: QuestionAnswer[]) { }
};

export class GetProblemQuestionsError implements Action {
    public type: string = ApplicationActionType.GetProblemQuestionsError;
    constructor(public payload?: any) { }
};

export class ConvertProblemQuestions implements Action {
  public type: string = ApplicationActionType.ConvertProblemQuestions;
  constructor(public payload?: QuestionsPayload[]) { }
};

export class ConvertProblemQuestionsSuccess implements Action {
    public type: string = ApplicationActionType.ConvertProblemQuestionsSuccess;
    constructor(public payload?: QuestionAnswer[]) { }
};

export class SetAnsweredProblemQuestions implements Action {
    public type: string = ApplicationActionType.SetAnsweredProblemQuestions;
    constructor(public payload: QuestionAnswer[]) { }
};

export class ResetAnsweredProblemQuestions implements Action {
    public type: string = ApplicationActionType.ResetAnsweredProblemQuestions;
    constructor() { }
};

export class SaveProblemTypeSearchLog implements Action {
    public type: string = ApplicationActionType.SaveProblemTypeSearchLog;
    constructor(public payload?: string) { }
};

export class CreateSaveSearchStubError implements Action {
    public type: string = ApplicationActionType.CreateSaveSearchStubError;
    constructor() { }
};

export class JumpToSystemError implements Action {
    public type: string = ApplicationActionType.JumpToSystemError;
    constructor() { }
};

export class ResetState implements Action {
    public type: string = ApplicationActionType.ResetState;
    constructor() { }
};

export class NoAction implements Action {
    public type: string = ApplicationActionType.NoAction;
    constructor() { }
};

export class DelayedActionBy1s implements Action {
    public type: string = ApplicationActionType.DelayedActionBy1s;
    constructor(public payload?: Action[]) { }
};

export type ApplicationAction =
    GetProblemMenuConfig |
    SetProblemMenuConfigItems |
    GetProblemMenuConfigError |
    ResetProblemMenuItems |
    FilterProblemMenuItems |
    SetFilterProblemMenuItemCount |
    UpdateProblemMenuDropdownState |
    SetCurrentStep |
    SetSelectedProblemMenuItemConfig |
    SetSelectedProblemMenuItemSuccess |
    SetSelectedCoordinates |
    SetSelectedLocationNameOrigin |
    SetSelectedLocationName |
    SetProblemDetails |
    SubmitPhoto |
    SavePhoto |
    UpdatePhotoUploadStatus |
    RemovePhoto |
    SetContactInfo |
    ClearSelectedProblemMenuItem |
    ClearSelectedProblemMenuItemSuccess |
    ClearSelectedLatLngCoordinates |
    ClearProblemDetails |
    ClearProblemPhotos |
    ClearContactInfo |
    CreateProblemStub |
    CreateProblemStubSuccess |
    CreateProblemStubError |
    SubmitProblem |
    SubmitProblemSuccess |
    SubmitProblemError |
    GetProblemQuestions |
    GetProblemQuestionsSuccess |
    GetProblemQuestionsError |
    SetAnsweredProblemQuestions |
    ResetAnsweredProblemQuestions |
    SaveProblemTypeSearchLog |
    CreateSaveSearchStubError |
    JumpToSystemError |
    ResetState |
    NoAction |
    DelayedActionBy1s
;
